// src/components/MainContent/MainContent.jsx
import React from 'react';
import ImageSection from './ImageSection';
import UploadForm from './UploadForm/UploadForm';
import './MainContent.css';

const MainContent = ({
    originalAudioFile,
    setOriginalAudioFile,
    candidateAudioFile,
    setCandidateAudioFile,
  handleSubmit
}) => (
  <main className="main-content">
    <ImageSection />
    <UploadForm 
      originalAudioFile={originalAudioFile}
      setOriginalAudioFile={setOriginalAudioFile}
      candidateAudioFile={candidateAudioFile}
      setCandidateAudioFile={setCandidateAudioFile}
      handleSubmit={handleSubmit}
    />
  </main>
);

export default MainContent;